import React, { useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout'; // 引入 Layout 组件
import './DataSync.css';

const host = process.env.REACT_APP_API_HOST; // API 地址

function DataSync() {
    const [syncStatus, setSyncStatus] = useState(''); // 用于显示同步状态

    // 第一个数据同步动作
    const handleSyncChatData = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No token found in local storage');
                navigate('/login');
                return;
            }

            setSyncStatus('正在同步chat数据到Review数据...');
            // 调用后端的 sync_chat_data API
            const response = await axios.post(`${host}/api/data/sync_chat_data`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setSyncStatus(response.data.message || '数据同步成功');
            alert('数据同步成功');
        } catch (error) {
            console.error('数据同步失败:', error);
            setSyncStatus('数据同步失败，请稍后重试');
            alert('数据同步失败，请稍后重试');
        }
    };

    // 第二个数据同步动作
    const handleSecondSyncAction = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No token found in local storage');
                navigate('/login');
                return;
            }

            setSyncStatus('正在获取用户修订问答数据...');
            // 调用后端的 chat_data API
            const response = await axios.get(`${host}/api/data/chat_data`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setSyncStatus(response.data.message || '获取用户修订问答数据成功');
            alert('获取用户修订问答数据成功');
        } catch (error) {
            console.error('获取用户修订问答数据失败:', error);
            setSyncStatus('获取用户修订问答数据失败，请稍后重试');
            alert('获取用户修订问答数据失败，请稍后重试');
        }
    };

    // 下载新数据
    const handleDownloadKnowledge = async () => {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error('No token found in local storage');
                navigate('/login');
                return;
            }

            setSyncStatus('正在下载新数据...');
            // 调用后端的 down_knowledge API
            const response = await axios.get(`${host}/api/data/down_knowledge`, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob', // 确保接收的是文件流
            });

            // 检查响应头是否包含 JSON（表示没有新数据）
            const contentType = response.headers['content-type'];
            if (contentType && contentType.includes('application/json')) {
                const reader = new FileReader();
                reader.onload = () => {
                    const responseData = JSON.parse(reader.result);
                    if (responseData.message === 'No new data available, CSV file not generated') {
                        setSyncStatus('没有新数据可供下载');
                        // alert('没有新数据可供下载');
                    }
                };
                reader.readAsText(response.data);
                return;
            }

            // 创建下载链接
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'reviewed_chat_data.csv'); // 设置下载文件名
            document.body.appendChild(link);
            link.click();
            link.remove();

            setSyncStatus('新数据下载成功');
            alert('新数据下载成功');
        } catch (error) {
            console.error('新数据下载失败:', error);
            setSyncStatus('新数据下载失败，请稍后重试');
            // alert('新数据下载失败，请稍后重试');
        }
    };

    return (
        <Layout>
            <div className="data-sync-page">
                <h1>数据同步</h1>
                <div className="sync-actions">
                <button className="sync-button" onClick={handleSecondSyncAction}>
                        获得客户端用户修订问答数据
                    </button>
                    <button className="sync-button" onClick={handleSyncChatData}>
                        同步用户修订问答数据用于审核
                    </button>
                    <button className="sync-button" onClick={handleDownloadKnowledge}>
                        下载审核后的新问答数据
                    </button>
                </div>
                {syncStatus && <p className="sync-status">{syncStatus}</p>}
            </div>
        </Layout>
    );
}

export default DataSync;